import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Star, EyeOff, Eye, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminReviews() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (rid) => { await api.post(`/admin/reviews/${rid}/hide`); load(); };
  const remove = async (rid) => {
    if (!window.confirm("Delete review permanently?")) return;
    await api.delete(`/admin/reviews/${rid}`); toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-reviews">
      <div className="flex items-end justify-between border-b border-border pb-4 mb-6">
        <div>
          <h1 className="font-display text-4xl tracking-tight">Reviews</h1>
          <p className="text-sm text-muted-foreground italic mt-1">Moderate reader reviews across the catalogue.</p>
        </div>
      </div>

      {items.length === 0 ? (
        <div className="text-sm text-muted-foreground italic text-center py-16 border border-dashed border-border rounded-sm">No reviews yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r.id} className={`border border-border rounded-sm p-4 bg-card ${r.hidden ? "opacity-60" : ""}`} data-testid={`rev-${r.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 text-sm">
                    <span className="font-medium">{r.user_name}</span>
                    <span className="text-xs text-muted-foreground">on</span>
                    <span className="font-display text-base">{r.product_title}</span>
                    {r.verified && <Badge variant="outline" className="rounded-sm text-[10px] font-normal">Verified</Badge>}
                    {r.hidden && <Badge variant="secondary" className="rounded-sm text-[10px] font-normal">Hidden</Badge>}
                  </div>
                  <div className="flex items-center gap-1 mt-1">
                    {[1,2,3,4,5].map((i) => <Star key={i} className={`h-3.5 w-3.5 ${i <= r.rating ? "fill-accent text-accent" : "text-muted-foreground/30"}`} strokeWidth={1.5} />)}
                    <span className="text-xs text-muted-foreground ml-2">{r.created_at?.slice(0, 10)}</span>
                  </div>
                  <p className="text-sm text-muted-foreground mt-2">{r.body}</p>
                </div>
                <div className="flex gap-1">
                  <Button variant="ghost" size="sm" onClick={() => toggle(r.id)} data-testid={`hide-${r.id}`}>
                    {r.hidden ? <Eye className="h-3.5 w-3.5" strokeWidth={1.5} /> : <EyeOff className="h-3.5 w-3.5" strokeWidth={1.5} />}
                  </Button>
                  <Button variant="ghost" size="sm" onClick={() => remove(r.id)} data-testid={`del-rev-${r.id}`}><Trash2 className="h-3.5 w-3.5" strokeWidth={1.5} /></Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
